// src/pages/Projects.js
import React from "react";
import "./Projects.css";
import projectsData from "../data/projectsData";

function Projects() {
  return (
    <div className="projects-container">
      <h1>My Projects</h1>
      <div className="projects-grid">
        {projectsData.map((project, index) => (
          <div
            className="project-card"
            key={index}
            style={{ backgroundImage: `url(${project.image})` }}
          >
            <div className="project-overlay">
              <h2>{project.title}</h2>
              <p>{project.description}</p>
              <div className="tech-stack">
                {project.techStack.map((tech, idx) => (
                  <span key={idx} className="tech-item">{tech}</span>
                ))}
              </div>
              <a href={project.github} target="_blank" rel="noopener noreferrer" className="view-button">
                VIEW
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
